<template>
    <form-switch v-if="params.data.type === 'HOUSEKEEPER'" @input="onChange" v-model="value" />
</template>

<script>
import formSwitch from '../../generic/form-switch/form-switch.vue';
export default {
    components: { formSwitch },
    data() {
        return {
            value: false,
        };
    },
    mounted() {
        this.value = this.params.data.is_enabled;
    },
    methods: {
        onChange(value) {
            this.params.onChange && this.params.onChange(this.params.data.id, value);
        },
    },
};
</script>

<style>
</style>